import ActionBar from './ActionBar';
import ActionBarContainer from './ActionBar.container';
export default ActionBarContainer(ActionBar);

//# sourceMappingURL=index.js.map